import { fromFetch } from 'rxjs/fetch';
import { AuthHeaders } from '../../models/auth-headers';
import { requiredHeaders } from '../../models/required-headers';
import { selectData } from '../../utils/select-data';
import { accountsEnvironment } from './accounts-environment';
import { copilotConfigsSchema } from './schemas/copilot-configs.schema';

export function getCopilotConfigs() {
  return fromFetch(
    new Request(accountsEnvironment.configSettingsAppUrl, {
      method: 'GET',
      headers: {
        ...requiredHeaders,
        ...new AuthHeaders(),
      },
    })
  ).pipe(selectData(copilotConfigsSchema));
}
